const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

const ThemeToggle = forgeUiComponent('ThemeToggle', null, function ThemeToggleConstructor(rootElement, options, componentBuilder) {
  const self = this;
  const darkButton = this.queryProperty('darkSwitch');
  const lightButton = this.queryProperty('lightSwitch');
  // if we're being honest the reason these props are named 'switch' not 'button' is so that 'lightSwitch' is a thing

  componentBuilder.defineClassState('darkRising', 'is-darkRising');
  componentBuilder.defineClassState('lit', 'is-lit');

  darkButton.addEventListener('click', function clickDarkButton(e) {
    e.stopPropagation();
    e.preventDefault();
    self.dispatchEvent(events.themeChange, { themeName: 'dark' }, e.target);
  });

  lightButton.addEventListener('click', function clickLightButton(e) {
    e.stopPropagation();
    e.preventDefault();
    self.dispatchEvent(events.themeChange, { themeName: 'light' }, e.target);
  });

  document.addEventListener(events.themeWasChanged, function (e) {
    self.handleThemeChange(e);
  });
});

ThemeToggle.prototype.handleThemeChange = function handleThemeChange(e) {
  const self = this;
  this.darkRising = false;
  this.lit = false;
  // HACK: Reset animation to ensure it plays again
  // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations/Tips#JavaScript_content
  requestAnimationFrame(function awaitRepaint() {
    requestAnimationFrame(function resetAnimationClass() {
      switch (e.detail.themeName) {
        case 'dark':
          self.darkRising = true;
          self.lit = false;
          break;
        case 'light':
          self.darkRising = false;
          self.lit = true;
          break;
        default: break;
      }
    });
  });
};

module.exports = ThemeToggle;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/theme-toggle.js
// module id = 75
// module chunks = 0